// Pure default-pick helper for the Laskutus picker on Tarkista (step 5).
// Spec: docs/superpowers/specs/2026-05-13-betonijerry-laskutus-step-design.md
//
// Rules (in order):
//   1. Empty / non-array list → null
//   2. Exactly one item → pick it
//   3. user.ownerAsiakasId set, !== 1349, and present in list → pick it
//   4. Otherwise → first item whose asiakasId !== 1349, or null

const UMBRELLA_ASIAKAS_ID = 1349;

export function defaultAsiakasFromList(list, user) {
    if (!Array.isArray(list) || list.length === 0) return null;

    // Filter out umbrella row early
    const realItems = list.filter((a) => a.asiakasId !== UMBRELLA_ASIAKAS_ID);

    // Single real item → pick it
    if (realItems.length === 1) return String(realItems[0].asiakasId);

    // Multiple real items: apply user preference or first
    const own = user?.ownerAsiakasId;
    if (own && own !== UMBRELLA_ASIAKAS_ID) {
        const match = realItems.find((a) => a.asiakasId === own);
        if (match) return String(match.asiakasId);
    }

    return realItems.length > 0 ? String(realItems[0].asiakasId) : null;
}
